import type { Provider, TestResult } from "./types";
import { connectionsApi } from "@/lib/api";
import { InstantlyIcon } from "@/components/providers/icons/InstantlyIcon";

/**
 * Instantly provider implementation
 */
export const instantlyProvider: Provider = {
  id: "instantly",
  type: "instantly",
  name: "",
  description:
    "Connect to your Instantly account to sync email campaigns and responses.",
  icon: InstantlyIcon,
  supportsAutoReply: true,
  hasSyncMechanism: true,
  configFields: [
    {
      name: "apiKey",
      label: "API Key",
      type: "password",
      required: true,
      placeholder: "Enter your Instantly API key",
      description: "Find this in your Instantly account settings",
    },
    {
      name: "workspace",
      label: "Workspace",
      type: "text",
      required: true,
      placeholder: "Enter your workspace name",
    },
    {
      name: "isActive",
      label: "Active",
      type: "toggle",
      required: false,
      description: "Enable or disable this connection",
    },
  ],
  validateConfig: async (config) => {
    if (!config.apiKey || !config.workspace) {
      return false;
    }
    return true;
  },
  testConnection: async (config): Promise<TestResult> => {
    try {
      const result = await connectionsApi.testConnection({
        sourceType: "instantly",
        apiKey: config.apiKey as string,
        workspace: config.workspace as string,
        isActive: config.isActive as boolean,
        autoReply: config.autoReply as boolean,
        minReplyDelaySeconds: config.minReplyDelaySeconds as number,
        maxReplyDelaySeconds: config.maxReplyDelaySeconds as number,
      });

      return {
        success: result.success,
        message: result.message || "Connection successful",
        details: result,
      };
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Connection failed",
      };
    }
  },
};
